import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import { errorMessage } from "../../reducers/subsite";
import { useForm } from "react-hook-form";
import LogoService from "../../services/logo.service";
import UploadLogo from "./UploadLogo";
const apiUrl = process.env.REACT_APP_LOCALHOST_URL;

const CreateLogoModal = (props) => {
    const createErrorMessage = useSelector(errorMessage);
    const [isSubmitting, setSubmitting] = React.useState(false);
    const [colors, setColors] = React.useState([]);
    const [file, setFile] = React.useState(null);

    console.log("PROPS", props);
    const { register, handleSubmit, formState: { errors } } = useForm({
        defaultValues: {
            decorationName: props.logo.decorationName,
            code: props.logo.code,
            decoType: props.logo.decoType,
            price: props.logo.price,
            decoColorId: props.logo.decoColorId,
            oppoColorId: props.logo.oppoColorId,
            light: props.logo.light,
            id: props.logo.id
        },
    });

    useEffect(() => {
        async function fetchData() {
            var colors = await LogoService.getLogoColors();
            setColors(colors.data);
            console.log("COLORS", colors.data);
        }
        fetchData();
    }, []);

    const onSubmit = async (data) => {
        data.uploadedImage = [file];
        await LogoService.addEditLogo(data);
        setSubmitting(false);
        modalClose(true);
    }

    const modalClose = (value) => {
        props.closeModal(value);
    }

    var label = "Add Decoration";

    if (props.logo.decorationName) {
        label = "Edit Decoration";
    }
    return (
        <Modal show={props.show} onHide={() => modalClose(false)}>
            <Modal.Header closeButton>
                <Modal.Title>{label}<br /></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Form.Group className="mb-3" controlId="decorationName">
                        <Form.Label>Name</Form.Label>
                        <input {...register("decorationName", { required: true })} /><br />
                        {errors.decorationName && <div className="error" >Name is required</div>}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="code">
                        <Form.Label>Code</Form.Label>
                        <input {...register("code", { required: true })} /><br />
                        {errors.code && <div className="error" >Code is required</div>}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="decoType">
                        <Form.Label>Type</Form.Label>
                        <select name="decoType"
                            {...register("decoType", {
                                required: true
                            })}>
                            <option value="" disabled>
                                Select type
                            </option>
                            <option value="EMBR">Embroidery</option>
                            <option value="VYNL">Transfer</option>
                            <option value="SCRN">Screen Print</option>
                        </select>
                        {errors.decoType && <div className="error" >Type is required</div>}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="price">
                        <Form.Label>Price</Form.Label>
                        <input {...register("price", { required: true })} /><br />
                        {errors.price && <div className="error" >Price is required</div>}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="uploadedImage">
                        <UploadLogo title="Decoration" register={register} fieldName="uploadedImage" bgColor="#CCCCCC" currentLogo={props.logo} setFile={setFile}/>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="decoColorId">
                        <Form.Label>Color</Form.Label>
                        <select name="decoColorId"
                            {...register("decoColorId", {
                                required: "select one option"
                            })}>
                            <option value="">
                                Select a Color
                            </option>
                            {colors && colors.map(color => (
                                <option value={color.id} selected={color.id === props.logo.decoColorId}>{color.colorName}</option>
                            ))}
                        </select>
                        {errors.decoColorId && <div className="error" >Color is required</div>}
                    </Form.Group>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => modalClose(false)}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit" onClick={handleSubmit(onSubmit)} disabled={isSubmitting}>
                            {label}
                        </Button>
                        {createErrorMessage}
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default CreateLogoModal; 